
export default () => {
    return {
        error: false,
        donating: false,
        donate() {
            this.donating = true;
            this.error = false;
            fetch(this.$refs.form.action, {
                headers: { 'X-Requested-With' : 'XMLHttpRequest' },
                method: 'POST',
                body: new FormData(this.$refs.form)})
            .then(res => res.json())
            .then(session => {
                if (session.id) {
                    return Stripe(this.$refs.stripe.value).redirectToCheckout({
                        sessionId: session.id,
                    });
                } else {
                    this.donating = false;
                    this.error = session.error;
                }
            })
            .then(result => {
                // If redirectToCheckout fails due to a browser or network error,
                // display the localized error message.
                this.donating = false
                if (result.error) {
                    alert(result.error.message);
                }
            })
            .catch(error => {
                this.donating = false
                console.log(error)
            })
        },
    }
}
